<template>
  <div class="page">
    <pcHeaders ></pcHeaders>

    <div class="banner">
      <div class="section">

        <div class="hen"
             style="margin-bottom: 20px;align-items: center;">
          <div style="margin-right: 0; font-size: 14px; height: 25px; line-height: 25px; width: 80px;">课程搜索：</div>
          <div class="searBoxs">
            <input type="text"
                   class="sear"
                   v-model="queryParams.className"
                   placeholder="搜索你想要的关键词">
            <div class="ss"
                 @click="handlSear">
              搜索
            </div>

            <div class="seletClass">
              <div style="display: flex;" @click="showSearFlag = !showSearFlag">
                <div>{{ searShowText }}</div>
                <div >
                  <img style="width: 10px;height: 10px;margin-left: 4px;margin-top: 4px;"
                       src="../../assets/images/zk_icon.png"
                       alt=""
                       v-if="showSearFlag">
                  <img style="width: 10px;height: 10px;margin-left: 4px;margin-top: 4px;"
                       src="../../assets/images/sq_icon.png"
                       alt=""
                       v-else>
                </div>
                <div class="su">

                </div>
              </div>

              <div class="showBox"
                   v-if="showSearFlag">
                <div @click="handSelet('1')">
                  班级
                </div>
                <div @click="handSelet('2')">
                  分类
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hen">
          <div style="margin-right: 0; font-size: 14px; height: 20px; line-height: 16px; margin-top: 5px; width: 80px;">选择类别：</div>
          <div style="display: flex; flex-wrap: wrap; width: 1262px; ">
            <div :class="tab1 == index ? 'selet1 seletActive1' : 'selet1'"
                 v-for="(item, index) in categoryList"
                 :key="item.ID"
                 :title="item.CODE_NAME"
                 @click="categoryHandel(item, index)">
              {{ item.CODE_NAME }}
            </div>
          </div>
        </div>

        <div class="hen"
             style="padding-top: 16px">
          <div style="margin-right: 0; font-size: 14px; height: 20px; line-height: 16px; margin-top: 5px; width: 80px;">选择项目：</div>
          <div style="display: flex; flex-wrap: wrap; width: 1262px; ">
            <div :class="tab2 == index ? 'selet seletActive' : 'selet'"
                 v-for="(item, index) in industryList"
                 :title="item.CODE_NAME"
                 :key="item.ID"
                 @click="industryHandel(item, index)">
              {{ item.CODE_NAME }}
            </div>
          </div>
        </div>

        <div class="hen"
             style="padding-top: 16px">
          <div style="margin-right: 0; font-size: 14px; height: 20px; line-height: 16px; margin-top: 5px; width: 80px;">课程类型：</div>

          <div style="display: flex; flex-wrap: wrap; width: 1262px; ">
            <div :class="tab3 == index ? 'selet seletActive' : 'selet'"
                 v-for="(item, index) in specialityList"
                 :title="item.CODE_NAME"
                 :key="item.ID"
                 @click="specialityHandel(item, index)">
              {{ item.CODE_NAME }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="banner1">
      <div style="color: #b0babf;font-size: 16px;margin-bottom: 20px;width: 1400px;"
           v-if="searText !== ''">
        找到 <span style="color: #ed906c;">{{ total }}</span> 条关于“{{searText}}”的信息
        <!-- <span style="color: #4076F6;cursor: pointer;margin-left: 30px;font-size: 14px;"
              @click="clerSear">重置搜索</span> -->
      </div>
      <div class="listBox"
           v-if="classList[0] !== ''"
           style="padding: 40px 30px">
        <div class="box_1"
             v-if="classList.length != 0">
          <div class="kcbRes"
               v-for="item in classList"
               :key="item.ID">
            <div class="kcB">
              <div class="fm">
                <img v-if="item.CLASS_IMAGE && item.CLASS_IMAGE !== null && item.CLASS_IMAGE !== ''"
                     style="width: 100%; height: 100%"
                     :src="item.CLASS_IMAGE"
                     @click="classDetail(item)"
                     :title="item.CLASS_NAME"
                     alt="中财专技"
                     @error="handleError" />
                <div class="fm"
                     v-else
                     @click="classDetail(item)"
                     style="position: relative; display: flex; justify-content: center; align-items: center">
                  <img style="position: absolute; top: 0; left: 0; z-index: 1; width: 100%; height: 100%"
                       src="../../assets/indexImg/noimg.png"
                       alt="中财专技" />
                  <div style="
                      font-size: 15px;
                      font-family: kaiti;
                      text-align: center;
                      padding: 0 10px;
                      font-weight: bold;
                      color: #355fd9;
                      position: relative;
                      z-index: 2;
                    ">
                    {{ item.CLASS_NAME }}
                  </div>
                </div>
              </div>
              <div style="padding: 0 10px"
                   @click="classDetail(item)">
                <div class="bt">{{ item.CLASS_NAME }}</div>
                <div class="fl">
                  <div class="flx"
                       style="margin-right: 6px;  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;">{{ item.lx }}</div>
                  <div class="flx"
                       style="margin-right: 6px">{{ item.CLASS_CREDITHOUR }}学时</div>
                  <div class="flx">{{ item.CLASS_TYPE == '01' ? '在线学习' : item.CLASS_TYPE == '02' ? '面授' : '混合' }}</div>
                </div>

                <div class="btm">
                  <div style="display: flex">
                    <div style="font-size: 14px; margin-top: 5px">¥</div>
                    <div v-if="item.ISCLASSAPPLY == '02'"
                         style="display: flex">
                      <div style="font-size: 20px">{{ item.CLASS_PRICE.toFixed(1) }}</div>
                    </div>

                    <div v-if="item.ISCLASSAPPLY == '01' || item.ISCLASSAPPLY == '' || item.ISCLASSAPPLY == null"
                         style="font-size: 20px;display: flex;align-items: center;">
                      {{ item.CREDIT_PRICE }}<div style="font-size: 14px">/学时</div>
                    </div>
                    <!-- <div style="margin-top: 7px; margin-left:4px;color: #888888; font-size: 12px">{{item.buyNum||0}}人报名</div> -->
                  </div>
                  <div class="skBtn"
                       @click="classDetail(item)">购买</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="kcb">
          <div class="forBox"  v-for="item in classList" :key="item.ID">
            <div class="imgBox">
              <img
                v-if="item.CLASS_IMAGE && item.CLASS_IMAGE !== null && item.CLASS_IMAGE !== ''"
                style="width: 100%; height: 100%"
                :src="item.CLASS_IMAGE"
                @click="classDetail(item)"
                alt="中财专技"
                @error="handleError"
              />
              <div
                class="imgBox"
                v-else
                @click="classDetail(item)"
                style="position: relative; display: flex; justify-content: center; align-items: center"
              >
                <img
                  style="position: absolute; top: 0; left: 0; z-index: 1; width: 100%; height: 100%"
                  src="../../assets/indexImg/noimg.png"
                  alt="中财专技"
                />
                <div
                  style="
                    font-size: 15px;
                    font-family: kaiti;
                    text-align: center;
                    padding: 0 10px;
                    font-weight: bold;
                    color: #355fd9;
                    position: relative;
                    z-index: 2;
                  "
                >
                  {{ item.CLASS_NAME }}
                </div>
              </div>
            </div>

            <div class="centerBox">
              <div class="top" @click="classDetail(item)">
                {{ item.CLASS_NAME }}
              </div>
              <div class="section-rgt-1">
                <span> {{ item.lx }}</span>
                <span>{{ item.CLASS_CREDITHOUR }}学时</span>
                <span>{{ item.CLASS_TYPE == '01' ? '在线学习' : item.CLASS_TYPE == '02' ? '面授' : '混合' }}</span>
              </div>

              <div class="botom">
                <div style="display: flex;align-items: flex-end"><div class="xs">
                  <span>¥</span>
                  {{ item.CLASS_PRICE.toFixed(1) }}
                </div><div class="bm">{{item.buyNum||0}}人报名</div></div>
                
                
                <div class="btn" @click="classDetail(item)" > 试看</div>
           
              </div>
            </div>
          </div></div> -->
        </div>
        <div style="display: flex; justify-content: center; align-items: center; font-size: 18px; margin-top: 100px; margin-bottom: 200px"
             v-if="recommendEmpty&&this.classList.length==0">
          暂无数据~
        </div>

      </div>
      <pagination v-show="total > 0"
                  :total="total"
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  :page-sizes="[12, 24, 48, 100]"
                  @pagination="getZypxClassList" />
    </div>

    <pcBottom></pcBottom>
    <flotRight />
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import { getZypxClassList, getClassList, getZypxProjectCodeList } from '@/api/list.js';
import { doShoppingCartZG } from '@/api/car.js';
import flotRight from '@/views/component/flotRight.vue';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom,
    flotRight
  },
  data() {
    // 这里存放数据
    return {
      categoryList: [], //类别
      industryList: [], //行业
      specialityList: [], //专业
      tab1: 0, //选中
      tab2: 0,
      recommendEmpty: false,
      tab3: '',
      queryParams: {
        pageNum: 1,
        pageSize: 12,
        className:'',
      },
      total: 0,
      classList: [''],
      codeNo: null, //跳转过来的code
      fCodeNo: null,
      defaultImageUrl: require('../../assets/images/noimg.png'),
      carFlag: true, //购物防止重复点击
      searText:'',
      showSearFlag: false,
      searType:'1',//1班级
      searShowText:'班级',
      codeNo1:'',
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {
    '$route.query.codeNo': function (newVal) {
      console.log('URL参数已经更新', newVal);
      this.codeNo = newVal;
      this.getList();
    },
    '$route.query.fCodeNo': function (newVal) {
      console.log('URL参数已经更新', newVal);
      this.fCodeNo = newVal;
    },
    '$route.query.className': function (newVal) {
      console.log('URL参数已经更新', newVal);
      this.queryParams.className = newVal;
      if (this.queryParams.className !== '') {
        this.tab1 = null;
        this.tab2 = null;
        this.tab3 = null;
        this.queryParams.codeNo = '';
      } else {
        this.tab1 = 0;
        this.tab2 = 0;
      }
      this.getZypxClassList();
    }
  },
  // 方法集合
  methods: {
    //选择搜索种类
    handSelet(id) {
      this.searType = id
      if (id == '1') {
        this.searShowText = '班级'
      }else {
        this.searShowText = '分类'
      }
      this.showSearFlag = false
    },
    //重置搜索
    clerSear() {
      this.queryParams.className = '';
      this.queryParams.codeNo = '';
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 12
      this.tab1 = null;
      this.tab2 = null;
      this.tab3 = null;
      this.getZypxClassList();
    },
    //搜索课程
    handlSear() {
      // this.tab1 = null;
      this.tab2 = null;
      this.tab3 = null;
      // this.queryParams.codeNo = '';
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 12
      this.queryParams.choose = this.searType
      if (this.codeNo1 == '') {
        this.queryParams.codeNo =  this.categoryList[0].CODE_NO
      }else { 
        this.queryParams.codeNo = this.codeNo1
      }
      this.getZypxClassList();
    },

    //公需课
    toGx() {
      this.$router.push('/gx');
    },
    //试听
    // tableHandel(row) {
    //   this.$router.push({
    //     path: '/classDetail',
    //     query: {
    //       classId: row.ID
    //     }
    //   });
    // },
    tableHandel(row) {
      this.$router.push({
        path: '/resources',
        query: {
          courseId: row.ID
        }
      });
    },
    purchase(item) {
      if (item.ISCLASSAPPLY == '02') {
        if (this.carFlag) {
          this.carFlag = false;
          //整体报名直接加入购物车
          doShoppingCartZG({ classId: item.ID }).then(res => {
            if (res.data.data.code == '1') {
              this.$message({
                message: '添加购物车成功！',
                duration: '1000',

                type: 'success'
              });
              this.$router.push('/car');
              this.carFlag = true;
            } else {
              this.$message({
                message: res.data.data.msg,
                duration: '1000',

                type: 'warning'
              });
              this.carFlag = true;
            }
          });
        }
        return false;
      }
      //非整体报名
      this.$router.push({
        path: '/purchase',
        query: {
          id: item.ID
        }
      });
    },
    //类别点击
    categoryHandel(item, index) {
      this.tab1 = index;
      this.queryParams.codeNo = item.CODE_NO;
      this.queryParams.pageNum = 1; //点击行业重置页数
      this.queryParams.className = ''; //清空输入框
      this.codeNo1 = item.CODE_NO;
      this.getZypxClassList();
      this.tab2 = null;
      this.tab3 = null;
      this.industryList = item.children;
      this.specialityList = [];
    },
    //行业点击
    industryHandel(item, index) {
      this.searType = ''
      this.queryParams.className = ''
      this.tab2 = index;
      this.tab3 = null;
      this.queryParams.codeNo = item.CODE_NO;
      this.queryParams.pageNum = 1; //点击行业重置页数
      this.getZypxClassList();
      this.specialityList = item.children;
    },
    //专业点击
    specialityHandel(item, index) {
      this.tab3 = index;
      this.queryParams.pageNum = 1; //点击行业重置页数
      this.queryParams.codeNo = item.CODE_NO;
      this.getZypxClassList();
    },
    //获取班级列表
    getZypxClassList() {
      getZypxClassList(this.queryParams).then(res => {
        this.classList = res.data.rows;
        this.total = res.data.total;
        this.searText = this.queryParams.className
        if (res.data.data.children !== null) {
            this.industryList = res.data.data.children
        }
        if (res.data.rows.length == 0) {
          this.recommendEmpty = true;
        }
      });
    },
    //班级详情
    classDetail(item) {
      this.$router.push({
        path: '/classDetail',
        query: {
          classId: item.ID
        }
      });
    },
    handleError(event) {
      event.target.src = this.defaultImageUrl;
    },
    getList() {

      getZypxProjectCodeList().then(res => {
        this.categoryList = res.data.data;
        let data = {
          CODE_NO: this.fCodeNo
        };
        
        if (this.codeNo == null && this.fCodeNo !== null) {
          this.categoryList.forEach((v, idx) => {
            if (v.CODE_NO == this.fCodeNo) {
              this.$nextTick(() => {
                this.tab1 = idx;
              });
              data.children = v.children;
            }
          });

          this.categoryHandel(data, '');
          return false;
        } else {
          this.queryParams.codeNo = this.categoryList[0].children[0].CODE_NO;
          this.industryList = this.categoryList[0].children;
          this.industryHandel(this.categoryList[0].children[0], 0);
        }
        
        
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    console.log(1);

    if (this.$route.query.codeNo || this.$route.query.fCodeNo) {
      this.fCodeNo = this.$route.query.fCodeNo;
    }
    this.queryParams.className = '';
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.scrollTo({ top: 0 });
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background: #f6f9fc;
}
.banner {
  font-family: Regular;
  display: flex;
  justify-content: center;

  .listBox {
    width: 1400px;
    padding-top: 20px;
    // padding: 30px;
    .forBox {
      width: 1400px;
      height: 225px;
      background: #ffffff;
      opacity: 1;
      border-radius: 6px;
      margin-bottom: 20px;
      padding: 20px 30px 20px 20px;
      display: flex;
      .imgBox {
        width: 230px;
        height: 185px;
        margin-right: 20px;
      }
    }
  }
  .section {
    width: 1400px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 2px 15px 0px rgba(138, 138, 138, 0.08), inset 0px 20px 50px 0px #f0f3f9;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #ffffff;
    margin-top: 20px;
    padding: 24px 30px;
    .hen {
      display: flex;
       .searBoxs {
        width: 380px;
        height: 46px;
        position: relative;
        .seletClass {
          position: absolute;
          top: 0;
          height: 46px;
          left: 20px;
          color: #4076f6;
          display: flex;
          align-items: center;
          cursor: pointer;
          font-size: 14px;
          .showBox {
            position: absolute;
            bottom: -55px;
            left: -15px;
            width: 59px;
            height: 64px;
            background: #ecf1fe;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
            border-radius: 6px 6px 6px 6px;
            div {
              width: 100%;
              height: 32px;
              text-align: center;
              line-height: 32px;
              color: #333;
            }
          }
          .su {
            width: 1px;
            height: 16px;
            background: #d6d6d6;
            margin-left: 13px;
          }
        }
        .sear {
          width: 380px;
          height: 46px;
          background: rgba(64, 118, 246, 0.1);
          border-radius: 25px;
          color: #8a8a8a;
          padding-left: 90px;
          padding-right: 90px;
          border: 0 !important;
        }
        .ss {
          text-align: center;
          line-height: 36px;
          width: 76px;
          height: 36px;
          background: #4076f6;
          border-radius: 21px 21px 21px 21px;
          background: #4076f6;
          border: 1px solid #4076f6;
          color: #fff;
          position: absolute;
          right: 5px;
          top: 5px;
          cursor: pointer;
          font-size: 14px;
        }
      }
      .selet1 {
        padding: 0 16px;
        font-size: 14px;
        margin-right: 12px;
        cursor: pointer;
        height: 25px;
        line-height: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 12px;
        color: #666;
      }
      .selet1:hover {
        background: #f6f6f6;
        color: #444444;
      }
      .seletActive1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #4076f6 !important;
        background: rgba(64, 118, 246, 0.1) !important;
        border-radius: 23px 23px 23px 23px;
      }
      .selet {
        padding: 0 16px;
        margin-top: 2px;
        font-size: 14px;
        margin-right: 12px;
        cursor: pointer;
        height: 25px;
        line-height: 25px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 12px;
        color: #666;
      }
      .selet:hover {
        background: #f6f6f6;
        color: #444444;
      }
      .seletActive {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #4076f6 !important;
        background: rgba(64, 118, 246, 0.1) !important;
        border-radius: 23px 23px 23px 23px;
      }
    }
  }
}
.banner1 {
  flex-direction: column;
  align-items: center;
  min-height: 510px;
  font-family: Regular;
  display: flex;
  justify-content: center;
  padding: 30px 30px;
  .listBox {
    // height:400px;
    width: 1400px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    margin-top: 20px;
    .box_1 {
      min-height: 334px;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
    }

    // .forBox {
    //   transition: all 0.2s  ease;
    //   margin-top: 30px;
    //   width: 200px;
    //   height: 274px;
    //   background: #ffffff;
    //   border-radius: 8px 8px 8px 8px;
    //   border: 1px solid #f3f3f3;
    //   display: flex;
    //   flex-direction: column;
    //   margin-left: 29px;
    //   margin-bottom: 30px;
    //   .imgBox {
    //     transition: all 0.2s  ease;
    //     width: 200px;
    //     height: 160px;
    //     border-radius: 8px 8px 0px 0px;
    //     img{
    //       border-radius: 8px 8px 0px 0px;
    //     }
    //   }
    //   .centerBox {
    //     display: flex;
    //     flex-direction: column;
    //     align-items: center;
    //     padding: 10px 0px 0px 2px;
    //     .top {
    //       font-family: PingFang SC, PingFang SC;
    //       font-weight: 500;
    //       font-size: 16px;
    //       color: #000000;
    //       width: 180px;
    //       white-space: nowrap;
    //       overflow: hidden;
    //       text-overflow: ellipsis;
    //       cursor: pointer;
    //     }
    //     .section-rgt-1 {
    //       margin-top: 7px;
    //       height: 24px;
    //       line-height: 24px;
    //       font-size: 12px;
    //       display: flex;
    //       width: 200px;
    //       justify-content: space-evenly;
    //       font-weight: 400;
    //       color: #666666;
    //       span:first-child {
    //         text-align: center;
    //         width: 60px;
    //         overflow: hidden;
    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //         background: #f6f6f6;
    //         border-radius: 2px 2px 2px 2px;
    //         font-family: PingFang SC, PingFang SC;
    //         display: inline-block;
    //       }
    //       span:nth-child(2) {
    //         display: inline-block;
    //         width: 60px;
    //         text-align: center;
    //         overflow: hidden;
    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //         background: #f6f6f6;
    //         border-radius: 2px 2px 2px 2px;
    //         font-family: PingFang SC, PingFang SC;
    //       }
    //       span:nth-child(3) {
    //         display: inline-block;
    //         width: 60px;
    //         text-align: center;
    //         overflow: hidden;
    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //         background: #f6f6f6;
    //         border-radius: 2px 2px 2px 2px;
    //         font-family: PingFang SC, PingFang SC;
    //         color: #666666;
    //       }
    //     }

    //     .botom {
    //       display: flex;
    //       width: 200px;
    //       margin-top: 12px;
    //       padding-left: 10px;
    //       align-items: flex-end;
    //       .xs {
    //         font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    //         font-weight: 500;
    //         font-size: 20px;
    //         color: #ff6632;
    //         margin-right: 8px;
    //         span {
    //           font-size: 14px;
    //         }
    //       }
    //       .bm {
    //         font-family: PingFang SC, PingFang SC;
    //         font-weight: 400;
    //         font-size: 12px;
    //         color: #888888;
    //       }
    //       .btn {
    //         display: none;
    //       }
    //     }
    //   }
    // }
    // .forBox:hover {
    //   transform: scale(1.1);
    //   margin-top: 20px;
    //   width: 200px;
    //   height: 274px;
    //   background: #ffffff;
    //   border-radius: 8px 8px 8px 8px;
    //   border: 1px solid #f3f3f3;
    //   display: flex;
    //   flex-direction: column;
    //   margin-bottom: 30px;
    //   .imgBox {
    //     width: 200px;
    //     height: 160px;
    //     border-radius: 8px 8px 0px 0px;
    //     img{
    //       border-radius: 8px 8px 0px 0px;
    //     }
    //   }
    //   .centerBox {
    //     display: flex;
    //     flex-direction: column;
    //     align-items: center;
    //     padding: 10px 0px 0px 2px;
    //     .top {
    //       font-family: PingFang SC, PingFang SC;
    //       font-weight: 500;
    //       font-size: 16px;
    //       color: #000000;
    //       white-space: nowrap;
    //       overflow: hidden;
    //       text-overflow: ellipsis;
    //       cursor: pointer;
    //     }
    //     .section-rgt-1 {
    //       margin-top: 7px;
    //       height: 24px;
    //       line-height: 24px;
    //       font-size: 12px;
    //       display: flex;
    //       justify-content: space-evenly;
    //       font-weight: 400;
    //       span:first-child {
    //         text-align: center;
    //         width: 60px;
    //         overflow: hidden;
    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //         background: rgba(64, 118, 246, 0.1);
    //         border-radius: 2px 2px 2px 2px;
    //         font-family: PingFang SC, PingFang SC;
    //         display: inline-block;
    //         color: #4076f6;
    //       }
    //       span:nth-child(2) {
    //         display: inline-block;
    //         width: 60px;
    //         text-align: center;
    //         overflow: hidden;
    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //         background: rgba(64, 118, 246, 0.1);
    //         border-radius: 2px 2px 2px 2px;
    //         color: #4076f6;
    //         font-family: PingFang SC, PingFang SC;
    //       }
    //       span:nth-child(3) {
    //         display: inline-block;
    //         width: 60px;
    //         text-align: center;
    //         overflow: hidden;
    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //         background: rgba(64, 118, 246, 0.1);
    //         border-radius: 2px 2px 2px 2px;
    //         font-family: PingFang SC, PingFang SC;
    //         color: #4076f6;
    //       }
    //     }

    //     .botom {
    //       display: flex;
    //       justify-content: space-between;
    //       padding:0 10px ;
    //       margin-top: 12px;
    //       padding-left: 10px;
    //       align-items: flex-end;
    //       .xs {
    //         font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    //         font-weight: 500;
    //         font-size: 20px;
    //         color: #ff6632;
    //         margin-right: 8px;
    //         span {
    //           font-size: 14px;
    //         }
    //       }
    //       .bm {
    //         display: none;
    //         // font-family: PingFang SC, PingFang SC;
    //         // font-weight: 400;
    //         // font-size: 12px;
    //         // color: #888888;
    //         // overflow: hidden;
    //         // white-space: nowrap;
    //         // text-overflow: ellipsis;
    //       }
    //       .btn {
    //         // margin-left: 44px;
    //         display: block;
    //         width: 54px;
    //         height: 28px;
    //         background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
    //         border-radius: 4px 4px 4px 4px;
    //         text-align: center;
    //         cursor: pointer;
    //         font-family: PingFang SC, PingFang SC;
    //         font-weight: 400;
    //         font-size: 12px;
    //         color: rgba(255, 255, 255, 0.93);
    //         line-height: 28px;
    //         text-align: center;
    //       }
    //     }
    //   }
    // }
  }
}
.kcB {
  border: 1px solid #f3f3f3;
  .imgBox {
    width: 200px;
    height: 160px;
    border-radius: 8px 8px 0px 0px;
    img {
      border-radius: 8px 8px 0px 0px;
    }
  }
  width: 200px;
  height: 274px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  cursor: pointer;
  overflow: hidden;
  .fm {
    width: 200px;
    height: 160px;
  }
  .bt {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    color: #000;
    margin: 10px 0 7px 0;
  }
  .fl {
    display: flex;
    .flx {
      width: 56px;

      padding: 3px 4px;
      height: 23px;
      background: #f6f6f6;
      border-radius: 2px 2px 2px 2px;
      text-align: center;
      // line-height: 23px;
      color: #666666;
      font-size: 12px;
    }
  }
  .btm {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    color: #ff6632;
    .skBtn {
      display: none;
      opacity: 0;
      width: 54px;
      height: 28px;
      background: linear-gradient(90deg, #6996ff 0%, #4093f6 100%);
      border-radius: 4px 4px 4px 4px;
      text-align: center;
      line-height: 28px;
      color: #fff;
      font-size: 12px;
    }
  }
}
.kcbRes {
  position: relative;
  width: 200px;
  height: 274px;
  margin-right: 28px;
  margin-bottom: 30px;

  .kcB:hover {
    box-shadow: 0px 5px 15px 0px rgba(138, 138, 138, 0.16);
    .imgBox {
      width: 220px !important;
      height: 160px !important;
      border-radius: 8px 8px 0px 0px;
      img {
        border-radius: 8px 8px 0px 0px;
      }
    }
    position: absolute !important;
    bottom: 0px !important;
    // left: -10px !important;
    width: 220px !important;
    height: 300px !important;
    background: #ffffff !important;
    border-radius: 8px 8px 8px 8px !important;
    cursor: pointer !important;
    transform: translate(-10px);
    /* 添加过渡效果 */
    transition: all 0.3s linear;

    .fm {
      width: 220px !important;
      height: 176px !important;
      /* 添加过渡效果 */
      transition: all 0.3s linear;
    }
    .skBtn {
      opacity: 1;
      display: inline-block;
      /* 添加过渡效果 */
      transition: all 0.5s;
    }
    .bt {
      color: #4076f6 !important;
      transition: all 0.3s;
    }
    .flx {
      background: rgba(64, 118, 246, 0.1) !important;
      color: #4076f6 !important;
      transition: all 0.3s;
    }
  }
}
.kcbRes:nth-child(6n) {
  margin-right: 0 !important;
}
</style>
